import {Repository} from '@s-ui/domain'

const getEmptyState = () => ({hasVisitedList: false, visitedAdIds: [], isTriggered: false})

const getSessionStorage = () => {
  try {
    return window.sessionStorage
  } catch (error) {
    return undefined
  }
}

// Best-effort session storage that never rejects: corrupt or unavailable storage resolves the
// empty state, so callers need no error branch.
export class SessionStorageCsatNpsRepository extends Repository {
  #config
  #storage

  constructor({config, storage}) {
    super()
    this.#config = config
    this.#storage = storage
  }

  // eslint-disable-next-line sui/decorator-async-inline-error
  static create({config}) {
    return new SessionStorageCsatNpsRepository({config, storage: getSessionStorage()})
  }

  // eslint-disable-next-line sui/decorator-async-inline-error
  async getState() {
    try {
      const {STORAGE_KEY} = this.#config.get('COMMON').CSAT_NPS
      const stored = JSON.parse(this.#storage.getItem(STORAGE_KEY))
      if (!stored || typeof stored !== 'object') return getEmptyState()

      return {
        hasVisitedList: stored.hasVisitedList === true,
        visitedAdIds: Array.isArray(stored.visitedAdIds) ? stored.visitedAdIds.map(String) : [],
        isTriggered: stored.isTriggered === true
      }
    } catch (error) {
      return getEmptyState()
    }
  }

  // eslint-disable-next-line sui/decorator-async-inline-error
  async saveState({state}) {
    try {
      const {STORAGE_KEY} = this.#config.get('COMMON').CSAT_NPS
      this.#storage.setItem(STORAGE_KEY, JSON.stringify(state))
    } catch (error) {}

    return state
  }
}
